<template>
  <div>
    <ConfirmModal
      v-if="user && showModal"
      :title="t('UserManagement.deleteUser.title', { email: user.email })"
      :cancel="t('UserManagement.deleteUser.cancel')"
      :approve="t('UserManagement.deleteUser.confirm')"
      :show-floating-close-button="false"
      data-testid="user-edit-del-modal"
      @close-dialog="closeDialog"
    />

    <BackLink class="mb-4" data-testid="user-edit-back" :to="{ name: 'userList' }">{{ t('backToOverview') }}</BackLink>

    <UserForm
      v-if="user"
      :header="String(t('UserManagement.editUserHeader'))"
      :submit-label="String(t('UserManagement.EditUser.CTAs.saveChanges'))"
      :user="user"
      data-testid="user-edit-form"
      @submit="editUserHandler"
    />
  </div>
</template>

<script setup lang="ts">
import { track } from '@ramp106/omrjs-tracking-reviews'
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useUserQuery, type RoleNameEnum } from '@/gql/myomr'
import BackLink from '@/ui/BackLink.vue'

import UserForm from './UserForm.vue'
import { useUserRoleEdit } from './useUserRoleEdit'

const { t } = useI18n()

const props = defineProps<{
  loading: boolean
  id: string
}>()

const emit = defineEmits(['reloadUsers'])

const { result } = useUserQuery({ userId: props.id })

const user = computed(() => result.value?.user)

const showModal = ref(false)

const { editUser } = useUserRoleEdit()
function editUserHandler({ roleNames: newRoleNames }: { roleNames: RoleNameEnum[] }) {
  track('user_update', { surface: 'editor' })

  if (newRoleNames.length === 0) {
    showModal.value = true
    return
  }

  if (user.value != null) editUser(user.value, newRoleNames, () => emit('reloadUsers'))
}

function closeDialog(confirm: boolean) {
  if (confirm && user.value != null) editUser(user.value, [], () => emit('reloadUsers'))
  showModal.value = false
}
</script>
